import { observer } from 'mobx-react-lite';
import { Card, Grid, Header, Icon, Message, Tab } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import format from 'date-fns/format';
import { getPermitColor } from '../../../app/common/util/util';
import { Permit } from '../../../app/models/permit';
import { FaShuttleVan, FaCarSide } from 'react-icons/fa';
import PermitDetails from '../details/PermitDetails';

const panes = [
    { menuItem: 'Active Permits', pane: { key: 'active' } },
    { menuItem: 'Pending Permits', pane: { key: 'pending' } },
    { menuItem: 'Expired Permits', pane: { key: 'expired' } }
];

export default observer(function PermitContentPermits() {
    const {permitStore, tabStore, modalStore} = useStore();
    const {loadingPermits, permits, getRouteName} = permitStore;
    const { tab : {activeIndex, predicate}, handleTabChange } = tabStore;
    const {openModal} = modalStore;
  
    return (
        <Tab.Pane
            className='no-border permits-container'
            loading={loadingPermits}
        >
            <Grid>
                <Grid.Column width={16}>
                    <Header floated='left' icon='slideshare' content={'Carpool/Vanpool Permits'} />
                </Grid.Column>
                <Grid.Column width={16}>
                    <Tab
                        panes={panes}
                        menu={{ secondary: true, pointing: true }}
                        onTabChange={(e, data) => handleTabChange(e, data)}
                        activeIndex={activeIndex}
                    />
                    
                    {permits.length === 0 ? 
                        <Message icon>
                            <Icon name='exclamation' />
                            <Message.Content>
                                <Message.Header>No Permits</Message.Header>
                                There are no {predicate} permits. Please try again later.
                            </Message.Content>
                        </Message>
                        : <br />
                    }
                    <Card.Group itemsPerRow={3} stackable doubling>
                        {permits.map((permit: Permit) => {
                            return (
                                <Card
                                    onClick={() => openModal(
                                        <PermitDetails permitId={`` + permit.permitId} />,
                                        '',
                                        false,
                                        undefined,
                                        'large'
                                    )}
                                    color={getPermitColor(predicate)}
                                    key={permit.permitId}
                                >
                                    <Card.Content>
                                    <Header 
                                as='h3'
                                color='teal' 
                                className='text-center'
                            >
                                {permit.permitTypeId === 2 ? (
                                    <>
                                        <FaCarSide className='custom-icon inline' />
                                        <Header.Content>Carpool Permit</Header.Content>
                                    </>
                                ) : (
                                    <>
                                        <FaShuttleVan className='custom-icon inline' />
                                        <Header.Content>Vanpool Permit</Header.Content>
                                    </>
                                )}
                            </Header>
                                    </Card.Content>
                                    <Card.Content>
                                        <Card.Header className='text-center' as='h4'>{getRouteName(+permit.routeId)} - #{permit.permitId}</Card.Header>
                                        <Card.Meta className='text-center'>
                                            Effective thru: {format(new Date(permit.permitDetail.effectiveThru), 'M/d/yyyy')}
                                        </Card.Meta>
                                        <Card.Description>
                                            Permit #: {permit.permitDetail.wsdoTPermitNbr !== '' ?
                                            'To be Assigned!' : permit.permitDetail.wsdoTPermitNbr}
                                        </Card.Description>
                                    </Card.Content>
                                </Card>
                            );
                        })}
                    </Card.Group>
                </Grid.Column>
            </Grid>
        </Tab.Pane>
    )
})